import { useKestrel } from 'features/kestrelViewer'
import { GenericEditButton } from 'features/kestrelViewer/kestrelViewerMarkup/utils/GenericEditButton'
import React, { FC, useMemo } from 'react'
import { Vector2 } from 'three'
import { KVCameraView } from 'types'

// Replace the any type with a proper interface
interface CameraViewData {
  id: string
  name: string
  notes: string
  cameraPosition: string
  cameraRotation: string
}

export const EditCameraViewButton: FC<{
  cameraView: KVCameraView
}> = ({ cameraView }) => {
  const { setPopupMenuStartPosition, setSelectedMarkup, cameraViews } =
    useKestrel()

  // Get the current camera view data from the cameraViews array
  const currentCameraView = useMemo(() => {
    const found = cameraViews?.find((cv) => cv.id === cameraView.id)
    return found || cameraView
  }, [cameraViews, cameraView])

  const handleEdit = () => {
    // Ensure we're setting a proper KVCameraView instance
    let cameraViewToSet: KVCameraView

    if (currentCameraView instanceof KVCameraView) {
      cameraViewToSet = currentCameraView
    } else {
      // Create a new KVCameraView instance from the data
      const data = currentCameraView as CameraViewData
      cameraViewToSet = new KVCameraView(data.id)
      cameraViewToSet.name = data.name
      cameraViewToSet.notes = data.notes
      cameraViewToSet.cameraPosition = data.cameraPosition
      cameraViewToSet.cameraRotation = data.cameraRotation
    }

    if (setPopupMenuStartPosition) {
      setPopupMenuStartPosition(new Vector2(80, 20))
    }
    setSelectedMarkup(cameraViewToSet)
  }

  return (
    <GenericEditButton
      itemId={cameraView.id}
      tooltipLabel='Edit camera view'
      onEdit={handleEdit}
    />
  )
}
